import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    confirmText: String,
    cancelText: String,
    icon: { type: String, default: "warning" }
  }

  confirm(event) {
    event.preventDefault()

    const form = event.target.closest('form')

    Swal.fire({
      title: this.titleValue || 'Sei sicuro?',
      text: this.textValue || 'Questa azione non può essere annullata',
      icon: this.iconValue,
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: this.confirmTextValue || 'Sì, elimina',
      cancelButtonText: this.cancelTextValue || 'Annulla',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        form.submit()
      }
    })
  }
}
